import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/utils"

export const inputVariants = cva(
  "flex w-full border-input text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "h-10 px-3 py-2 border rounded-md ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        minimal: "p-0 outline-none"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
)

export interface InputContainerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof inputVariants> {
}

export const InputContainer: React.FC<InputContainerProps> = ({
  className, variant, children, ...props
}) => {
  return (
    <div
      className={cn(inputVariants({ variant, className }))}
      {...props}
    >
      {children}
    </div>
  )
}


export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, type, ...props }, ref) => {
    return (
      <input
        type={type}
        formNoValidate={true}
        className={cn(inputVariants({ variant, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"
